const BOLD_REGEX = /\{b\}(.*?)\{\/b\}/g;

export function parseBoldSegments(text) {
  const segments = [];
  const regex = new RegExp(BOLD_REGEX.source, "g");
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push({ bold: false, text: text.substring(lastIndex, match.index) });
    }
    segments.push({ bold: true, text: match[1] });
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    segments.push({ bold: false, text: text.substring(lastIndex) });
  }

  return segments.length > 0 ? segments : [{ bold: false, text }];
}

export function wrapWordsHtml(text) {
  if (!text) return "";

  const tokens = text.match(/\S+|\s+/g);
  if (!tokens?.length) return "";

  let leading = "";
  const words = [];

  for (const token of tokens) {
    if (/^\s+$/.test(token)) {
      if (words.length === 0) {
        leading += token;
      } else {
        words[words.length - 1] += token;
      }
    } else {
      words.push(token);
    }
  }

  if (leading && words.length) {
    words[0] = leading + words[0];
  } else if (leading) {
    words.push(leading);
  }

  return words
    .map((word) => `<span class="word">${word}</span>`)
    .join("");
}

function wrapSegmentHtml(segment) {
  const wrapped = wrapWordsHtml(segment.text);
  return segment.bold ? `<strong>${wrapped}</strong>` : wrapped;
}

export function buildAnimatedTextHtml(text) {
  if (typeof text !== "string") return "";

  const lines = text.split("\n");

  return lines
    .map((line, index) => {
      const lineHtml = parseBoldSegments(line).map(wrapSegmentHtml).join("");
      const lineBreak = index < lines.length - 1 ? "<br />" : "";
      return lineHtml + lineBreak;
    })
    .join("");
}
